import styled from '@emotion/styled';
import { Stack, Typography } from '@mui/material';
import { theme } from 'theme';
import { transientOptions } from 'utils/transientOptions';

export const LabelTitle = styled(Typography)`
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  text-align: center;
  color: ${theme.palette.label.primary};
  text-align: center;
`;

export const LabelSubTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
  color: ${theme.palette.label.primary};
  opacity: 50%;
`;

export const BoxWrapper = styled(Stack)`
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  margin-top: 10px;
  margin-bottom: 45px;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  & > div {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    justify-content: center;
    text-align: center;
    align-items: center;
    width: 200px;
    color: ${theme.palette.primary.main};
    & .title-step {
      font-size: 20px;
      font-weight: 700;
      color: #193f56;
    }
  }
`;

interface ButtonProps {
  isnextbutton?: boolean;
}
export const StyledButtonWrapper = styled(Stack, transientOptions)<ButtonProps>`
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 12px;
  ${theme.breakpoints.down('md')} {
    flex-direction: column;
  }
  & > button {
    margin-top: 10px;
    width: ${({ isnextbutton }) => (isnextbutton ? '40%' : '300px')};
    max-width: 600px;
    margin: ${({ isnextbutton }) => (isnextbutton ? 'auto' : 'unset')};
    ${theme.breakpoints.down('sm')} {
      width: 280px;
    }
  }
`;

interface ImageVectorProps {
  isUseTransform?: boolean;
}
export const ImageVector = styled('img', transientOptions)<ImageVectorProps>`
  width: 45px;
  height: 24px;
  transform: ${({ isUseTransform }) =>
    !isUseTransform ? 'unset' : 'rotateX(180deg)'};
  margin-top: ${({ isUseTransform }) => (isUseTransform ? '60px' : '20px')};
  ${theme.breakpoints.down('sm')} {
    transform: unset;
    margin: unset;
  }
`;
